<div [formGroup]="setupForm">
  <div class="setup-intro">
    <p>
      Use this tile to build a hero banner with layered headings, imagery, links, and icons. Each
      section below controls a specific part of the hero layout.
    </p>
  </div>

  <mat-card>
    <mat-card-header>
      <mat-card-title>Heading 1</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="section-intro">Controls the primary hero heading text and its typography.</p>
      <lib-text-editor
        [formGroup]="setupForm"
        textFormControlName="heading1"
        fontColorFormControlName="heading1FontColor"
        fontSizeFormControlName="heading1FontSize"
      ></lib-text-editor>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Heading 2</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="section-intro">Controls the secondary hero heading shown alongside the main title.</p>
      <lib-text-editor
        [formGroup]="setupForm"
        textFormControlName="heading2"
        fontColorFormControlName="heading2FontColor"
        fontSizeFormControlName="heading2FontSize"
      ></lib-text-editor>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Introduction</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="section-intro">Adds the supporting introductory copy for the hero banner.</p>
      <lib-text-editor [formGroup]="setupForm" textFormControlName="text"></lib-text-editor>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>Feature Image</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="section-intro">Sets the featured image shown inside the hero content area.</p>
      <mat-form-field>
        <mat-label>Image URL</mat-label>
        <input matInput formControlName="contentImg" />
        <mat-hint>Defines the main image displayed inside the hero banner.</mat-hint>
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>Background Image</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="section-intro">Controls the background image and its offsets around the hero.</p>
      <lib-image-editor
        [formGroup]="setupForm"
        imageUrlFormControlName="background"
        imageOffsetTopFormControlName="backgroundImageTopOffset"
        imageOffsetLeftFormControlName="backgroundImageLeftOffset"
        imageOffsetBottomFormControlName="backgroundImageBottomOffset"
        imageOffsetRightFormControlName="backgroundImageRightOffset"
      ></lib-image-editor>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>Buttons</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div [formGroup]="setupForm">
        <p class="section-intro">Add optional links or calls to action shown in the hero.</p>
        <lib-links-editor
          [linksFormArray]="setupForm.controls.linkButtons"
          [tileInstance]="tileInstance"
        ></lib-links-editor>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>Icons</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div [formGroup]="setupForm">
        <p class="section-intro">Add supporting icons and define how each one should look.</p>
        <ng-container *ngFor="let icon of iconsControl.controls; let i = index">
          <div [formGroup]="icon" class="icons-container">
            <div class="inputs-container">
              <mat-form-field appearance="fill">
                <mat-label>Icon</mat-label>
                <input matInput formControlName="icon" />
                <mat-hint>Sets the icon shown for this hero item.</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Icon Style</mat-label>
                <mat-select formControlName="iconStyle">
                  <mat-option *ngFor="let iconStyle of iconStylesOptions" [value]="iconStyle.key">
                    {{ iconStyle.name }}
                  </mat-option>
                </mat-select>
                <mat-hint>Chooses the visual treatment applied to the icon.</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="fill" class="color-input">
                <mat-label>Icon Color</mat-label>
                <input type="color" matInput formControlName="iconColor" />
                <mat-hint>Sets the primary color of the icon.</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="fill" class="color-input">
                <mat-label>Icon Outline Color</mat-label>
                <input type="color" matInput formControlName="iconOutlineColor" />
                <mat-hint>Sets the outline color used for the icon.</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="fill" class="color-input">
                <mat-label>Icon Background Color</mat-label>
                <input type="color" matInput formControlName="iconBackgroundColor" />
                <mat-hint>Sets the background color shown behind the icon.</mat-hint>
              </mat-form-field>
            </div>

            <mat-icon class="delete-btn" (click)="removeIcon(i)">delete_forever</mat-icon>
          </div>
        </ng-container>

        <button class="add-btn" mat-raised-button color="primary" (click)="addIcon()">Add Icon Column</button>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="footer">
    <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
  </div>
</div>
